var niwakufukuOddsTable = {
  computed: {
    // 枠用にデータ用意
    wakuEntries: function() {
      var wakuNums = {};
      for (var syaban in this.voteInfo.entries) {
        
        if (!wakuNums[this.voteInfo.entries[syaban].waku_num.toString()]) {
          wakuNums[this.voteInfo.entries[syaban].waku_num.toString()] = {};
        }
        
        wakuNums[this.voteInfo.entries[syaban].waku_num.toString()][syaban] = this.voteInfo.entries[syaban].name;
      }
      
      return wakuNums;
    }
  },
  template: `
    <table class="table table-vote-number w100per">
      <tr class="text-center">
        <th></th>
        <th v-for="(item, key) in wakuEntries" :class="'bg-lighten-' + key">{{ key }}</th>
        <th></th>
      </tr>
      <tr class="text-center">
        <th>名前</th>
        <th v-for="(item, key) in wakuEntries" :class="'bg-lighten-' + key" class="vam">
          <p v-for="(name, syaban, index) in item">{{ syaban }} {{ name }}</p>
        </th>
        <th>名前</th>
      </tr>
      <tr class="text-center">
        <th>府県</th>
        <th v-for="(item, key) in wakuEntries" :class="'bg-lighten-' + key">{{ item.locker_ground }}</th>
        <th>府県</th>
      </tr>
      <tr v-for="(row, wakuNum2, index) in wakuEntries" v-if="wakuNum2 > 1" class="text-center">
        <th :class="'bg-lighten-' + wakuNum2">{{ wakuNum2 }}</th>
        <td v-for="(col, wakuNum1) in wakuEntries">
          <a class="block" v-if="voteInfo.oddsTableData[ wakuNum1 + '-' + wakuNum2 ]" @click.prevent="addOddsTableItems(voteInfo.oddsTableData[ wakuNum1 + '-' + wakuNum2 ], wakuNum1 + '-' + wakuNum2)" :class="{'is-absent': !voteInfo.oddsTableData[wakuNum1 + '-' + wakuNum2 ].is_valid}">
            {{ voteInfo.oddsTableData[ wakuNum1 + '-' + wakuNum2 ].normalize_rate }}
          </a>
        </td>
        <th :class="'bg-lighten-' + wakuNum2">{{ wakuNum2 }}</th>
      </tr>
    </table>
  `
};

export default {
  niwakufukuOddsTable
}